import * as actions from '../constants/all';
import * as models from '../../models/action/core';
import { ActivityType } from '../../models/components/lesson-upcoming-activity';

export function newNotification(text: string,
    title?: string,
    onClick?: any,
    position: 'default' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' = 'topRight',
    notificationType: 'info' | 'success' | 'error' | 'warning' = 'info',
    timeOut?: number | 'fixed', spinnerId?: string, spinnerType?: 'get' | 'set'): models.INotificationAction {
    return {
        type: actions.coreActions.CORE_NOTIFICATION,
        title,
        onClick,
        notificationType,
        position,
        timeOut,
        timestamp: Date.now(),
        text,
        spinnerId,
        spinnerType
    };
}

export function setSpinner(spinnerId?: string, spinnerType?: 'get' | 'set'): models.IAction {
    return {
        type: actions.coreActions.SET_SPINNER,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}

export function activityTypeSetAction(activityType: ActivityType | null, activityId: string | null): models.ISetActivityType {
    return {
        activityType,
        activityId,
        timestamp: Date.now(),
        type: actions.coreActions.SET_ACTIVITYTYPE_WITHMODAL
    };
}
